import React from 'react';
import { Link } from 'react-router-dom';
import { services } from '../mockData';
import * as Icons from 'lucide-react';
import { ArrowRight } from 'lucide-react';

const Services = () => {
  return (
    <div className="min-h-screen">
      {/* Hero Section */}
      <section className="bg-gradient-to-br from-indigo-600 via-purple-600 to-indigo-800 text-white py-24">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="max-w-4xl">
            <h1 className="text-5xl md:text-6xl font-bold mb-6">Our Services</h1>
            <p className="text-xl text-indigo-100">
              Delivering domain expertise and technology-driven offerings to help you turn digital challenges into opportunities. We provide end-to-end solutions across AI, cloud, data, security, and more.
            </p>
          </div>
        </div>
      </section>

      {/* Services Grid */}
      <section className="py-20">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {services.map((service) => {
              const IconComponent = Icons[service.icon] || Icons.Code;
              return (
                <Link
                  key={service.id}
                  to={`/services/${service.slug}`}
                  className="group bg-white rounded-2xl p-8 border-2 border-gray-200 hover:border-indigo-500 hover:shadow-2xl transition-all duration-300 hover:-translate-y-1"
                >
                  <div className="w-16 h-16 bg-gradient-to-br from-indigo-500 to-purple-600 rounded-xl flex items-center justify-center mb-6 group-hover:scale-110 transition-transform duration-300">
                    <IconComponent className="w-8 h-8 text-white" />
                  </div>
                  <h3 className="text-2xl font-bold text-gray-900 mb-3 group-hover:text-indigo-600 transition-colors duration-200">
                    {service.name}
                  </h3>
                  <p className="text-gray-600 mb-6">{service.shortDescription}</p>
                  <div className="flex items-center text-indigo-600 font-medium group-hover:translate-x-2 transition-transform duration-200">
                    <span>Learn more</span>
                    <ArrowRight className="w-5 h-5 ml-2" />
                  </div>
                </Link>
              );
            })}
          </div>
        </div>
      </section>
    </div>
  );
};

export default Services;